import config from '@frolight/config';
import HTTPStatusError from '@frolight/utils/HTTPStatusError';

const AUTH_ROOT_URL = `${config.api.uri}/auth`;
const SIGN_IN_URL = `${AUTH_ROOT_URL}/sign-in`;
const REFRESH_TOKEN_URL = `${AUTH_ROOT_URL}/refresh-token`;

export const signIn = async (abortController, { username, password }) => {
  try {
    const response = await fetch(SIGN_IN_URL, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json; charset=UTF-8'
      },
      body: JSON.stringify({
        username: username,
        password: password
      }),
      credentials: 'include',
      signal: abortController.signal
    });

    if (!response.ok) {
      throw new HTTPStatusError(response.status, response.statusText);
    }

    const data = await response.json();
    return data;
  } catch (err) {
    if (err.name !== 'AbortError') {
      if (err instanceof HTTPStatusError) {
        throw err;
      }
      throw new Error(`Error signing in: ${err.message}`);
    }
  }
};

export const refreshAccessToken = async (abortController) => {
  try {
    const response = await fetch(REFRESH_TOKEN_URL, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json; charset=UTF-8'
      },
      credentials: 'include',
      signal: abortController.signal
    });

    if (!response.ok) {
      throw new HTTPStatusError(response.status, response.statusText);
    }

    const data = await response.json();
    return data;
  } catch (err) {
    if (err.name !== 'AbortError') {
      if (err instanceof HTTPStatusError) {
        throw err;
      }
      throw new Error(`Error refreshing access token: ${err.message}`);
    }
    // Aborted
    return undefined;
  }
};

export const signOut = async (abortController, accessToken) => {
  try {
    const response = await fetch(REFRESH_TOKEN_URL, {
      method: 'DELETE',
      headers: {
        'Accept': 'application/json',
        'Authorization': `${accessToken.type} ${accessToken.token}`,
        'Content-Type': 'application/json; charset=UTF-8'
      },
      credentials: 'include',
      signal: abortController.signal
    });

    if (!response.ok) {
      throw new HTTPStatusError(response.status, response.statusText);
    }

    const data = await response.json();
    return data;

  } catch (err) {
    if (err.name !== 'AbortError') {
      if (err instanceof HTTPStatusError) {
        throw err;
      }
      throw new Error(`Error signing out`, err);
    }
  }
};
